const patientgroup = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Patient Group",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Page Title",
                      placeholder: "Enter title",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    text: {
                      type: "ckeditor",
                      label: "Page Description",
                      placeholder: "Enter Description",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr0: {
                      type: "hr",
                      size: "12",
                    },
                    ppg_form: {
                      type: "toggle",
                      label: "PPG Form",
                      placeholder: "Select PPG Form",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    // "ppg_form_select": {
                    //     "type": 'pdfSelect',
                    //     "label": 'Select PDF',
                    //     "placeholder": 'Select PDF',
                    //     "hideLabel": true,
                    //     "displayOn": "ppg_form",
                    //     "displayOnValue": 'true',
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    ppg_form_select: {
                      type: "select",
                      label: "Select",
                      hideLabel: true,
                      placeholder: "Select",
                      displayOn: "ppg_form",
                      displayOnValue: "true",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["Template A", "Template B"],
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                      displayOn: "suggestion_form",
                      displayOnValue: "true",
                    },
                    suggestion_form: {
                      type: "toggle",
                      label: "Suggestion Form",
                      placeholder: "Select Suggestion Form",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    suggestion_form_select: {
                      type: "select",
                      label: "Select",
                      hideLabel: true,
                      placeholder: "Select",
                      displayOn: "suggestion_form",
                      displayOnValue: "true",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["Template A", "Template B"],
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    ppg_documents: {
                      type: "toggle",
                      label: "PPG Documents",
                      placeholder: "Select PPG Documents",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    ppg_documents_list: {
                      type: "variableList",
                      label: "PPG Documents List",
                      placeholder: "Select",
                      displayOn: "ppg_documents",
                      displayOnValue: "true",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    ppg_newsletters: {
                      type: "toggle",
                      label: "PPG News",
                      placeholder: "Select PPG News",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    ppg_newsletters_list: {
                      type: "variableList",
                      label: "PPG News List",
                      placeholder: "Select",
                      required: false,
                      displayOn: "ppg_newsletters",
                      displayOnValue: "true",
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    ppg_minutes: {
                      type: "toggle",
                      label: "PPG Minutes",
                      placeholder: "Select PPG Minutes",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    ppg_minutes_list: {
                      type: "variableList",
                      label: "PPG Minutes List",
                      placeholder: "Select",
                      displayOn: "ppg_minutes",
                      displayOnValue: "true",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                    ppg_news: {
                      type: "toggle",
                      label: "PPG Newsletters",
                      placeholder: "Select PPG News",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    ppg_news_list: {
                      type: "variableList",
                      label: "PPG News List",
                      placeholder: "Select",
                      required: false,
                      displayOn: "ppg_news",
                      displayOnValue: "true",
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr6: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "FAQ",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New FAQ",
                type: "page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Question",
                    placeholder: "Enter Question",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  answer: "",
                },
              },
            },
            children: [
              {
                type: "patientGroupTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Questions",
                  type: "list",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Question",
                      placeholder: "Enter Question",
                      required: true,
                      info: false,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    answer: {
                      type: "ckeditor",
                      label: "Answer",
                      placeholder: "Enter Answer",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { patientgroup };
